import Icon, { IconTypes } from '../../generic/Icon';

import React from 'react';
import SVGIcon from '../../generic/SVGIcon';
import { mergeClassNames } from '../../../utils/mergeClassnames';
import styles from './index.module.scss';

export default function ButtonControls({
  slides,
  activeSlideIndex,
  setActiveSlideIndex,
  className = '',
  activeClassName = '',
}) {
  return (
    <div className={mergeClassNames(styles.buttonControls, className)}>
      {slides.length > 1 &&
        slides.map((slide, index) => {
          let title = slide.shortHeading || slide.heading;
          let activeSlide = activeSlideIndex === index;
          return (
            <button
              key={index}
              onClick={() => setActiveSlideIndex(index)}
              className={mergeClassNames(activeSlide ? [styles.active, activeClassName] : null)}
              title={title}
            >
              {slide.icon ? (
                <SVGIcon className={styles.imgIcon} svgIcon={slide.icon} />
              ) : (
                <Icon className={styles.svgIcon} IconType={IconTypes.wallpaper} />
              )}
              {activeSlide ? <span className={styles.buttonTitle}>{title}</span> : ''}
            </button>
          );
        })}
    </div>
  );
}
